export default "https://assets.egbcdn.net/assets/packs/_/images/chat/chat-send-0d5ece8421d215eb4ea9baac717930d5.png";